<template>
  <div
    id="app"
    :class="isMobile ? 'adaptiveMobileClassStyle' : ''"
    @click="gotnapShare"
  >
    <!-- <Nap v-if="allPark && !isMobile"/> -->
    <Nap v-if="allPark" />
    <!-- <div style="height: 80px" v-if="allPark && !isMobile"></div> -->
    <div style="height: 80px" v-if="allPark"></div>
    <router-view />
    <!-- <Footer v-if="allPark && !isMobile"/> -->
    <Footer v-if="allPark" />
    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
import Nap from "./components/header/nap";
import Footer from "./components/footer/index";
import chatDialog from "./components/chat/chatDialog";
import { mapMutations, mapState } from "vuex";
// import { component } from 'vue/types/umd';
import api from "./utils/api";
import { awaitPost } from "./utils/api";
import { getNewcurrent } from "./utils/interface";
import * as RongIMLib from "@rongcloud/imlib-next";

export default {
  name: "App",
  components: {
    Nap,
    Footer,
    chatDialog,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    ...mapState({
      allPark: "allPark",
      chatRecord: "chatRecord",
    }),
  },
  async created() {
    if (this.$isMobile()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.isTokenDoorVuex(false);
    // let tokenAll = this.$cookies.get("api_access_token");
    // let apiNewToken = this.$cookies.get("api_token_new");
    let tokenAll = this.$cookies.get("api_access_token");
    let apiNewToken = this.$cookies.get("api_token_new");
    // 一进来时判断是否有newToken，如果没有就把登录的状态改外false，如果有就把登录的状态改为true

    // console.log(tokenAll , apiNewToken,tokenAll == null,apiNewToken === null)

    // tokenAll === apiNewToken ||
    if (apiNewToken == null) {
      this.isLoginVuex(false);
      api
        .tokenFirst()
        .then((res) => {
          // console.log("res", res);
          if (res.data && res.data.access_token) {
            let token = res.data.access_token;
            // this.$cookies.set(
            //   "api_access_token_time",
            //   `${new Date().getTime()}`
            // );
            // this.$cookies.set("api_access_token", token);
            this.$cookies.set(
              "api_access_token_time",
              `${new Date().getTime()}`
            );
            this.$cookies.set("api_access_token", token);
          } else {
            console.error("获取access_token失败。");
            // 清除token重新获取
            this.$cookies.remove("api_access_token_time");
            this.$cookies.remove("api_access_token");
          }
          this.isTokenDoorVuex(true);
        })
        .catch((err) => {
          this.$router.push("undefined");
          // alert("接口报错");
        });
    } else {
      this.isLoginVuex(true);
      api
        .tokenFirst()
        .then((res) => {
          // console.log("res", res);
          if (res.data && res.data.access_token) {
            let token = apiNewToken;
            this.$cookies.set(
              "api_access_token_time",
              `${new Date().getTime()}`
            );
            this.$cookies.set("api_access_token", token);
          } else {
            console.error("获取access_token失败。");
            // 清除token重新获取
            this.$cookies.remove("api_access_token_time");
            this.$cookies.remove("api_access_token");
          }
          this.isTokenDoorVuex(true);
        })
        .catch((err) => {
          this.$router.push("undefined");
          // alert("接口报错");
        });
      getNewcurrent()
        .then((res) => {
          this.isStorageUsermessage(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //初始化融云
    RongIMLib.init({ appkey: "6tnym1br6yci7" });

    //设置监听
    this.initListener();
  },

  destroyed() {
    //删除监听
    this.removeListener();
  },

  methods: {
    ...mapMutations([
      "isTokenDoorVuex",
      "isLoginVuex",
      "isStorageUsermessage",
      "clearChatRecords",
      "isShare_con",
    ]),
    //鼠标点击任意位置关闭弹框
    gotnapShare() {
      this.isShare_con(false);
    },
    initListener() {
      let that = this;
      // 连接状态监听器
      const Events = RongIMLib.Events;
      /**
       * 正在链接的事件状态
       */
      RongIMLib.addEventListener(Events.CONNECTING, () => {
        console.log("正在链接...");
      });

      /**
       * 链接到服务器会触发这个事件
       */
      RongIMLib.addEventListener(Events.CONNECTED, () => {
        console.log("连接成功");
      });

      /**
       * 手动调用 disconnect 方法或者用户被踢下线 会触发这个事件
       */
      RongIMLib.addEventListener(Events.DISCONNECT, () => {
        console.log("连接中断，需要业务层进行重连处理");
      });

      /**
       * 链接出问题时，内部进行重新链接，会出发这个事件
       */
      RongIMLib.addEventListener(Events.SUSPEND, () => {
        console.log("链接中断，SDK 会尝试重连，业务层无需关心");
      });
      // 消息监听器
      RongIMLib.addEventListener(Events.MESSAGES, function(messages) {
        console.log(messages);
        messages.messages.forEach((message, index) => {
          if (message.senderUserId !== that.$store.state.isUsermessage.uuid) {
            let type = 1;
            if (message.messageType.indexOf("Img") != -1) {
              type = 2;
            }
            if (message.messageType.indexOf("File") != -1) {
              type = 3;
            }
            let say = {
              //自定义消息组件所需参数
              type: type,
              css: "left",
              txt: message.content,
              date: "",
              headImg: "",
            };
            if (!that.chatRecord[message.targetId]) {
              that.clearChatRecords(message.targetId);
            }
            that.chatRecord[message.targetId].push(say);
            that.$set(that.chatRecord, that.chatRecord[message.targetId], say);
          } else {
            messages.messages.splice(index, 1);
          }
        });
        if (messages.messages.length > 0 && !that.$store.state.isChatting) {
          //获取会话未读数
          const includeMuted = false;
          const conversationTypes = [RongIMLib.ConversationType.PRIVATE];
          RongIMLib.getTotalUnreadCount(includeMuted, conversationTypes)
            .then((res) => {
              if (res.code === 0) {
                that.$store.state.unReadMsgCount = res.data;
              } else {
                console.log(res.code, res.msg);
              }
            })
            .catch((error) => {
              console.log(error);
            });
          that.$notify.info({
            title: "消息",
            message: "有新的消息，请及时查看！",
            duration: 5000,
            position: "bottom-right",
            onClick() {
              getNewcurrent()
                .then((res) => {
                  that.isStorageUsermessage(res);
                  let user = that.$store.state.isUsermessage;
                  that.$refs.chatDialogRef.initReply(
                    user.uuid,
                    user.name,
                    user.headUrl
                  );
                })
                .catch((err) => {
                  console.log(err);
                });
            },
          });
        }
      });
    },

    //清除事件监听
    removeListener() {
      const Events = RongIMLib.Events;
      RongIMLib.removeEventListeners(Events.MESSAGES);
    },
  },
};
</script>

<style lang="less">
// 富文本的样式默认修改  v-html
.vHtmlMess {
  //   white-space: pre-wrap;
  font-size: 26rpx;
  /deep/img,
  /deep/video {
    max-width: 100% !important;
    height: auto;
  }
  /deep/table {
    border: none;
    border-collapse: collapse;
    max-width: 100% !important;
  }
  /deep/table td,
  /deep/table th {
    border: 2rpx solid #ccc;
    padding: 6rpx 10rpx;
    min-width: 100rpx;
    height: 40rpx;
  }
  /deep/table th {
    border-right: 2rpx solid #ccc;
    border-bottom: 4rpx solid #ccc;
    text-align: center;
    background-color: #f1f1f1;
  }
}
/* #app {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
    } */
// h4 {
//     font-family: "Avenir", Helvetica, Arial, sans-serif;
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
// }

* {
  /* margin: 0 auto; */
  margin: 0;
  padding: 0;
  font-family: "PingFangSC-Regular", sans-serif;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0px;
}

li {
  list-style: none;
}

input,
textarea,
select,
a:focus {
  outline: none;
}

a {
  text-decoration: none;
  color: inherit;
}

html,
body,
#app,
.home,
.banner {
  // height: 100%;
  margin: 0px;
}

button {
  outline: none;
}

.flex {
  display: flex;
}

.el-message {
  z-index: 9999999 !important;
}

.editorStyleDetailContent {
  white-space: pre-wrap;

  .video-wrap {
    text-align: center;
  }

  video {
    margin: 0 auto;
    display: flex;
  }

  ol {
    padding-left: 20px;

    li {
      list-style-type: decimal;
    }
  }

  ul {
    padding-left: 20px;

    li {
      list-style-type: disc;
    }
  }

  p {
    min-height: 28px;
  }
}

/*适配手机新闻页样式*/
.adaptiveMobileClassStyle {
  width: 100%;
  height: 100%;
  // 新闻页面
  .adaptiveMobileNewClass {
    width: 100%;
    height: 100%;
    margin: 0;
    padding-bottom: 0 !important;
    background: #fff !important;
    .new_top_nap {
      display: none;
    }
    .new_con {
      width: 96%;
      border-radius: 4px;

      h2 {
        padding: 15px;
        font-size: 18px;
      }

      .new_con_mess {
        margin: 20px 0 20px;
        padding: 0 10px 20px;
        border-bottom: none;
      }

      .new_bottom {
        padding: 0 10px 20px;
        display: none;

        .new_bottom_left {
          width: 50%;

          p {
            width: 88%;
          }
        }

        .new_bottom_right {
          p:nth-of-type(2) {
            width: 40%;
          }
        }
      }

      .new_con_box {
        padding: 0 10px;
        flex-wrap: wrap;
        display: block;

        .new_con_right {
          justify-content: flex-end;
          display: none;
        }

        .new_con_left {
          justify-content: space-between;
          flex-wrap: wrap;

          p {
            margin-right: 0;
          }
        }
      }
    }
    .new_top_nap {
      padding: 20px 3%;
    }
  }
  // 3D模型库详情
  // .adaptiveMobileModelDetails {
  //     // margin: 15px;

  //   .modelDeta_loc_top {
  //     display: none;
  //   }
  //   .modelDeta_loc_top,.modelDeta_topBox,.modelDeta_center {
  //     width: 100%;
  //   }
  //   .modelDeta {
  //     .modelDeta_topBox {
  //       .modelDeta_topBox2 {
  //         width: 100%;
  //         .modelDeta_top {
  //           flex-wrap: wrap;
  //           .modelDeta_top_imgs {
  //             .modelDeta_thumbnailImg {
  //               display: none;
  //             }
  //           }
  //         }
  //       }
  //       .modelDeta_loc {
  //         padding: 0 15px;
  //         .modelDeta_loc_titleBox {
  //           width: 100% !important;
  //         }
  //       }
  //       .modelDeta_top {
  //         .modelDeta_top_imgs {
  //           width: 100%;
  //           height: 100%;
  //           .toolBars {
  //             display: none;
  //           }
  //         }
  //         .modelDeta_top_content {
  //           margin-top: 20px;
  //         }
  //       }
  //     }
  //     .modelDeta_center {
  //       width: 100%;
  //     }
  //     .modelDeta_bottom {
  //       width: 100%;
  //     }
  //   }

  // }
  //设计市场详情
  // .adaptiveMobileDesignDetails{
  //     width: 100%!important;
  //     .details{
  //         width: 100%!important;
  //         display: flex;
  //         flex-wrap: wrap;
  //         // white-space: wrap;
  //         .details_left{
  //             width: 100%!important;
  //         // display: none;
  //         // margin-right: 0!important;
  //         .currentPosition{
  //             width: 100%;
  //         }
  //         .quotedPrice{
  //             margin-right: 30px;
  //         }
  //         .left_top{
  //             .left_top_mess {
  //                 // width: 100%;
  //                 // display: none;
  //                 .left_top_share {
  //                     p{
  //                         display: flex;
  //                     }
  //                     width: 100px;
  //                    margin-left: -20px;

  //                 }
  //             }
  //         }
  //         .budget{
  //             // width: 100%;
  //             flex-wrap: wrap;
  //             .budgetLeft{
  //                 margin-top: 10px;
  //             }
  //             .budgetRight{
  //                 margin-top: 10px;
  //             }
  //             }
  //             .left_top_mess{
  //                 width: 100%;
  //                 ul{
  //                     margin-right: 30px;
  //                 }
  //                 .stepLine{
  //                     width: 2px;
  //                 }
  //                 .left_top_share{
  //                     p{
  //                         width: 100px;
  //                         padding-bottom: 20px;
  //                     }
  //                 }
  //             }
  //         }
  //         .details_right{
  //             width: 100%!important;

  //         }
  //     }

  // }
}
</style>



// WEBPACK FOOTER //
// src/App.vue